export const ALL_TIME = "allTime";

export const PAGE_LIMIT = 10;
